import { AnimatePresence, motion } from 'motion/react';
import { CheckCircle2, AlertTriangle, Info } from 'lucide-react';
import { useToastStore } from '@/stores/toast.store';
import { cn } from '@/lib/cn';

const icons = { success: CheckCircle2, error: AlertTriangle, info: Info };

export function Toaster() {
  const toasts = useToastStore((s) => s.toasts);
  return (
    <div
      aria-live="polite"
      className="pointer-events-none fixed inset-x-0 top-4 z-[60] flex flex-col items-center gap-2 px-4"
    >
      <AnimatePresence initial={false}>
        {toasts.map((toast) => {
          const Icon = icons[toast.tone];
          return (
            <motion.div
              key={toast.id}
              layout
              initial={{ opacity: 0, y: -12, scale: 0.98 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: -8, scale: 0.98 }}
              transition={{ duration: 0.2, ease: [0.22, 1, 0.36, 1] }}
              className="glass pointer-events-auto flex max-w-md items-center gap-2.5 rounded-xl px-4 py-2.5 text-sm font-medium shadow-panel ring-1 ring-line-strong"
            >
              <Icon
                className={cn(
                  'size-4 shrink-0',
                  toast.tone === 'success' && 'text-success',
                  toast.tone === 'error' && 'text-danger',
                  toast.tone === 'info' && 'text-volt-300',
                )}
              />
              {toast.text}
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
}
